import React from 'react'
import { Icon } from '@mobi/component-library/Assets/Icon'
import type { ThemeName } from './Banner.styles'
import { colors } from '@mobi/component-library/Foundations'

type Props = { theme: ThemeName }

const IconSize = '2.4rem'

const BannerIcon = ({ theme }: Props): JSX.Element | null => {
  switch (theme) {
    case 'neutral':
      return <Icon name='DuocolorInfoCircle' size={IconSize} color={colors.white} />
    case 'primary':
      return <Icon name='DuocolorShieldTick' size={IconSize} />
    case 'success':
      return <Icon name='DuocolorCheckCircle' size={IconSize} />
    case 'warning':
      return <Icon name='DuocolorAlertCircle' size={IconSize} color={colors.white} />
    case 'error':
      return <Icon name='DuocolorAlertTriangle' size={IconSize} color={colors.white} />
    default:
      return null
  }
}
export default BannerIcon
